export const HEADER_X_ORGANIZATION_COMPANY = 'X-Organization-Company';
